import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import type { AsyncCallbackStatus } from '@wix/cli-ui-kit';
import { Alert, Spinner } from '@wix/cli-ui-kit';

export const ActionStatus: FC<{
  status: AsyncCallbackStatus<unknown>;
  loadingText: string;
  successText: string;
}> = ({ status, loadingText, successText }) =>
  match(status, {
    NotRequested: () => null,
    Loading: () => <Spinner text={loadingText} />,
    Error: () => null,
    Success: () => <Alert type="success">{successText}</Alert>,
  });
